import { AxiosInstance } from 'axios'
import { createOptimizedAPI } from '../utils'
import { IStandardizedConceptSingleLanguage } from '../../../types/concept.types'
import { IConceptCreate } from './concepts'

export interface IEntityConceptResponse {
  id: string;
  last_update: string;
  entity_type: string;
  created: string;
  concepts: IStandardizedConceptSingleLanguage[];
}

interface IEntity {
  entity_type: string;
  texts: {
    text: string;
    format: 'plain' | 'html_with_mention';
  }[];
}

export function entitiesApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v2/learning/entities'
  const methods = {
    getEntityConcepts(entityAlias: string) {
      return api.get<IStandardizedConceptSingleLanguage[]>(`${baseUrl}/${entityAlias}/concepts`)
    },
    createEntityConcept(entityAlias: string, conceptId: string, obj: Omit<IConceptCreate, 'ontology_id'>) {
      return api.post<void>(`${baseUrl}/${entityAlias}/concepts/${conceptId}`, obj)
    },
    deleteEntityConcept({
      entityAlias,
      conceptId,
      languageId,
      label_match
    }: {
      entityAlias: string,
      conceptId: string,
      languageId: string | undefined,
      label_match: string
    }) {
      return api.delete<void>(`${baseUrl}/${entityAlias}/concepts/${conceptId}/languages/${languageId}/labels/${encodeURIComponent(label_match)}`)
    },
    createOrUpdateEntity(entityAlias: string, obj: IEntity) {
      return api.put<IEntityConceptResponse>(`${baseUrl}/${entityAlias}`, obj)
    }
  }
  return createOptimizedAPI(methods)
}
